/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// 25 Sept 2026 (Mike): no "Subscribe Now and Save" on single item product pages (breakfasts, snacks, the Parmo and so
// on). Subscribe and Save is chosen in the basket and applies to meals only. Recurpay adds its box (#recurpay-pdp-widget)
// to every product page, so it is hidden here and its tick box is cleared, so nothing is added as a subscription. The
// weekly meal plan pages are left as they were.
(function () {
  var path = window.location.pathname;
  if (!/\/products\//.test(path)) { return; }
  if (/complete-package|weekly-meal-prep-plan/.test(path)) { return; }
  var style = document.createElement('style');
  style.textContent = '#recurpay-pdp-widget, .recurpay__widget { display: none !important; }';
  (document.head || document.documentElement).appendChild(style);
  document.addEventListener('DOMContentLoaded', function () {
    var clearTicks = function () {
      document.querySelectorAll('#recurpay-pdp-widget input[type="checkbox"], .recurpay__widget input[type="checkbox"]').forEach(function (box) {
        if (box.checked) { box.checked = false; box.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    };
    clearTicks();
    setTimeout(clearTicks, 1500);
  });
})();

document.addEventListener("DOMContentLoaded", function() {
  var recurpayCartForm = document.querySelector('[action="/cart"]');

  // The basket form only exists when there is something in the basket.
  // Without this check the whole block threw on an empty basket.
  if (window.location.href.indexOf("/cart") > -1 && recurpayCartForm) {

    window.planIntervals = {};
    window.planIntervals.intervals = [];
    window.recurpayCart = {};
    window.subscriptionTitleArr = [];
    

    // 26 Sept 2026 (Mike): Subscribe and Save is a card in the basket's own style, with a heading and (when the basket
    // has breakfasts or snacks) a note that it is not for them. The widget, its ids, names, values and labels are as
    // before. The basket's CSS (snippets/cart-meal-builder) places the card and hides it when nothing can go on it.
    recurpayCartForm.insertAdjacentHTML("beforebegin",`
<div class="mbd-card mbd-sub" data-mbd-sub><div class="mbd-card__head"><h2 class="mbd-card__title">How would you like to order?</h2></div><div id="recurpay-cart-widget">
<label for="one_time"><input type="radio" id="one_time" name="subscription_purchase" value="one_time"><span class="recurpay__checkmark"></span>One time purchase</label>
<label for="subscription">
<input type="radio" id="subscription" name="subscription_purchase" value="subscription"><span class="recurpay__checkmark"></span>Subscribe and Save</label></div><p class="mbd-sub__note">Subscribe and Save is for meals and weekly meal plans, not breakfasts or snacks.</p></div>
`);
    document.querySelector('[for="subscription"]').insertAdjacentHTML("beforeend",'<div id="data-frequency-options"></div>');
    // 26 Sept 2026 (Mike): on phones the plan drop-down could not fit "Weekly Subscription (Save 10%)". With one plan
    // the drop-down is hidden and the plan is written out under Subscribe and Save (see mbd-one-plan below), outside
    // the label, so tapping the text does not tick Subscribe and Save. It always shows, so the saving is seen before
    // choosing. With more than one plan the drop-down stays, full width on phones.
    var mbdPlanStyle = document.createElement('style');
    mbdPlanStyle.textContent = '#data-frequency-options.mbd-one-plan #plan-selection{display:none !important}' +
      '#recurpay-cart-widget .mbd-plan-info{padding:0 10px 4px;text-align:left}' +
      '#recurpay-cart-widget .mbd-plan-note{display:block;font-size:14px;line-height:1.4;font-weight:600;color:#2a7563;white-space:normal;text-transform:none;letter-spacing:0}' +
      '#recurpay-cart-widget .mbd-plan-desc{display:block;margin-top:2px;font-size:13px;line-height:1.4;font-weight:400;color:#6a6a6a;white-space:normal;text-transform:none;letter-spacing:0}' +
      '@media (max-width:640px){#recurpay-cart-widget #plan-selection{width:100%;font-size:14px}}';
    (document.head || document.documentElement).appendChild(mbdPlanStyle);

    fetch('/cart.json').then(function(response) {
      return response.json();
    }).then(function(data) {
      window.recurpayCart = data;
      var cartItems = data.items;
      
      if(cartItems.length >0){
        
        var cartProducts = [];

        for(var i=0; i < cartItems.length; i++){
          var item = cartItems[i];

          cartProducts.push(item.product_id);

          if (item.selling_plan_allocation && subscriptionTitleArr.indexOf(item.selling_plan_allocation.selling_plan.name) === -1) {
            subscriptionTitleArr.push(item.selling_plan_allocation.selling_plan.name);
          }
          
        }
        
        function recurPDPModal(data){
          data.plans.forEach(plan => {
            if(plan.properties){
              window.planIntervals.intervals.push({
                interval:plan.properties.interval,
                title:plan.name,
                discount:plan.discount.value,
                description:plan.description
              });
            }
          });
        }
        
//           Getting all the plans associated with the cart products and filtering out all plans
        
        async function postData(url = '', data = {}) {
          const response = await fetch(url, {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          });
          return response.json(); 
        }

        postData('https://macro-based-diner-1.recurpay.com/api/storefront/products/plans.json/restructure', {products: cartProducts})
        .then( response => {
          var collectionWidgetHTML = '';
          if(response != "ERROR" && response.success == true) {
            window.allPlans = response.data.plans;
            if(response.data.plans.length > 0){
              for(var i=0;i<response.data.plans.length;i++){
                recurPDPModal(response.data.plans[i]); 
              }
              var keyInterval = 'title';
              var filterInterval = [...new Map(window.planIntervals.intervals.map(item => [item[keyInterval], item])).values()];
              var htmlInterval = '';

              filterInterval.forEach(item => {
                if (item.discount != 0 ) {
                  htmlInterval += `<option value="${item.title}" data-title="${item.title}" data-description="${item.description}" data-discount="${item.discount}" data-plan-interval="${item.interval}">${item.title} <strong>(Save ${item.discount}%)</strong></option>`
                }
                else {
                  htmlInterval += `<option value="${item.title}" data-title="${item.title}" data-description="${item.description}" data-discount="${item.discount}" data-plan-interval="${item.interval}">${item.title}</option>`
                }
              });

              var selectData = '<select id="plan-selection"><option disabled value="noPlan" hidden selected>Select Frequency</option>'+htmlInterval+'</select>';

              document.querySelector('#data-frequency-options').innerHTML = selectData;

              // 26 Sept 2026 (Mike): with only one plan there is nothing to choose, so the drop-down is hidden (it stays in
              // the page for the code below) and the plan is written out, e.g. "Weekly Subscription: save 10% on your
              // meals", with Recurpay's plan description under it. Ticking Subscribe and Save applies the plan.
              if (filterInterval.length == 1) {
                var mbdPlan = filterInterval[0];
                var mbdPlanBox = document.querySelector('#data-frequency-options');
                var mbdSubLabel = document.querySelector('[for="subscription"]');
                var mbdInfo = document.createElement('div');
                mbdInfo.className = 'mbd-plan-info';
                mbdInfo.id = 'mbd-plan-info';
                var mbdNote = document.createElement('span');
                mbdNote.className = 'mbd-plan-note';
                mbdNote.textContent = mbdPlan.title + (mbdPlan.discount != 0 ? ': save ' + mbdPlan.discount + '% on your meals' : '');
                mbdInfo.appendChild(mbdNote);
                // Read as text through DOMParser, which never runs or loads anything in the description; paragraphs are
                // joined with a space.
                var mbdDescText = '';
                try {
                  var mbdDoc = new DOMParser().parseFromString(mbdPlan.description || '', 'text/html');
                  var mbdParts = mbdDoc.body.querySelectorAll('p, li');
                  mbdDescText = (mbdParts.length ? Array.prototype.map.call(mbdParts, function (p) { return p.textContent; }).join(' ') : mbdDoc.body.textContent || '').replace(/\s+/g, ' ').trim();
                } catch (err) {}
                if (mbdDescText) {
                  var mbdDesc = document.createElement('span');
                  mbdDesc.className = 'mbd-plan-desc';
                  mbdDesc.textContent = mbdDescText;
                  mbdInfo.appendChild(mbdDesc);
                }
                if (mbdSubLabel && mbdSubLabel.parentNode) {
                  mbdSubLabel.parentNode.insertBefore(mbdInfo, mbdSubLabel.nextSibling);
                  var mbdSubRadio = document.querySelector('#subscription');
                  if (mbdSubRadio) { mbdSubRadio.setAttribute('aria-describedby', 'mbd-plan-info'); }
                }
                mbdPlanBox.classList.add('mbd-one-plan');
              }

              if (subscriptionTitleArr.length == 1 ) {
                document.querySelector('#plan-selection').value = subscriptionTitleArr[0];
                document.querySelector('[value="subscription"]').checked = true;
              }
              else if ( subscriptionTitleArr.length == 0 ) {
                document.querySelector('[value="one_time"]').checked = true;
              }

            }
          }
        });
        
//           ----------------------------------------------------------------------------
        
        // 25 Sept 2026 (Mike): Subscribe and Save did nothing. Recurpay's own script replaces window.recurpayCart with a
        // copy of the basket whose items have no properties, so setting "Plan" on them threw an error and no basket line
        // was ever changed. Now the basket is read fresh when the choice changes, every line is changed in turn by its
        // key (it was all lines at once by position), and the page reloads when they are done, so every price, Subtotal
        // and the Basket total are right. Ticking Subscribe and Save applies the plan straight away when there is only
        // one plan to choose from; with more plans the customer picks from the list as before.
        // The line properties are unchanged apart from "Plan" and "_PlanId", exactly as before.
        var mbdPlanBusy = false;
        function mbdApplyPlan(planName) {
          if (mbdPlanBusy || !window.allPlans) { return; }
          mbdPlanBusy = true;
          var widget = document.querySelector('#recurpay-cart-widget');
          if (widget) { widget.setAttribute('aria-busy', 'true'); widget.style.opacity = '0.6'; }
          fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
            return response.json();
          }).then(async function (cart) {
            var changes = [];
            // 25 Sept 2026 (Mike): the 10% is for meals only. Breakfasts and snacks keep the Breakfast Bundle instead, so
            // they are never put on the subscription (the basket lists them in window.mbdNoSubscribeProducts).
            var noSubscribe = window.mbdNoSubscribeProducts || [];
            (cart.items || []).forEach(function (item) {
              var properties = Object.assign({}, item.properties || {});
              if (planName && noSubscribe.indexOf(item.product_id) > -1 && !item.selling_plan_allocation) { return; }
              if (planName && noSubscribe.indexOf(item.product_id) > -1) {
                // Already on a plan from before: take it off.
                properties['Plan'] = '';
                properties['_PlanId'] = '';
                changes.push({ id: item.key, quantity: item.quantity, selling_plan: null, properties: properties });
                return;
              }
              if (planName) {
                var productPlans = window.allPlans.find(function (x) { return x.product_id == item.product_id; });
                var plan = productPlans ? productPlans.plans.find(function (y) { return y.name == planName; }) : undefined;
                if (!plan) { return; }
                if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id == plan.selling_plan_id) { return; }
                properties['Plan'] = planName;
                properties['_PlanId'] = plan.id;
                changes.push({ id: item.key, quantity: item.quantity, selling_plan: plan.selling_plan_id, properties: properties });
              } else {
                if (!item.selling_plan_allocation && !properties['Plan']) { return; }
                properties['Plan'] = '';
                properties['_PlanId'] = '';
                changes.push({ id: item.key, quantity: item.quantity, selling_plan: null, properties: properties });
              }
            });
            for (var j = 0; j < changes.length; j++) {
              await fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify(changes[j])
              }).catch(function () {});
            }
            // 25 Sept 2026 (Mike): Subscribe and Save is not used with discount codes, so any code comes off.
            var clearedCodes = false;
            if (planName && cart.discount_codes && cart.discount_codes.length) {
              await fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ discount: '' })
              }).catch(function () {});
              clearedCodes = true;
            }
            if (changes.length || clearedCodes) { window.location.reload(); return; }
            mbdPlanBusy = false;
            if (widget) { widget.removeAttribute('aria-busy'); widget.style.opacity = ''; }
          }).catch(function () {
            mbdPlanBusy = false;
            if (widget) { widget.removeAttribute('aria-busy'); widget.style.opacity = ''; }
          });
        }

        document.addEventListener('change', function (e) {
          if (!e.target) { return; }
          if (e.target.id == 'plan-selection') {
            var subscriptionRadio = document.querySelector('#subscription');
            if (subscriptionRadio) { subscriptionRadio.checked = true; }
            mbdApplyPlan(e.target.value);
          }
          if (e.target.id == 'subscription') {
            var planSelect = document.querySelector('#plan-selection');
            if (planSelect) {
              var planOptions = Array.from(planSelect.options).filter(function (o) { return !o.disabled; });
              if (planOptions.length == 1) {
                planSelect.value = planOptions[0].value;
                mbdApplyPlan(planOptions[0].value);
              }
            }
          }
          if (e.target.id == 'one_time') {
            var planSelection = document.querySelector('#plan-selection');
            if (planSelection) { planSelection.value = 'noPlan'; }
            mbdApplyPlan('');
          }
        });

      }
    }).catch(function() {
      console.log("Error");
    });

  } 
}) 